module.exports = __webpack_public_path__ + "static/media/file_type_video_icon.4d4d9c12.svg";